import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import countries from "../../constant/countries";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CountryCard = () => {
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (countryName) => {
    if (selectedCountries.includes(countryName)) {
      // If already selected, remove it
      setSelectedCountries((prev) =>
        prev.filter((name) => name !== countryName)
      );
    } else if (selectedCountries.length < 5) {
      // Add if under limit
      setSelectedCountries((prev) => [...prev, countryName]);
    } else {
      toast.warning("You can select a maximum of 5 countries.");
    }
  };

  const handleSubmit = () => {
    if (selectedCountries.length === 0) {
      toast.error("Please select at least one country.");
      return;
    }

    navigate("/pinkhelp/advertising-portal/selected", {
      state: { selectedCountries },
    });
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md mx-auto">
      <h2 className="text-xl font-bold text-blue-600 mb-4">
        Select Your Countries
      </h2>

      <p className="text-gray-700 mb-4">
        Choose up to <span className="font-semibold">5 countries</span> for just
        <span className="font-semibold"> $2 per country/month</span>. Customize
        your outreach!
      </p>

      <div className="relative">
        <button
          onClick={toggleDropdown}
          className="w-full bg-blue-100 text-blue-700 font-medium py-2 px-4 rounded border border-blue-300 shadow-sm hover:bg-blue-200 transition"
        >
          {isOpen ? "Hide Countries" : "Show Country List"}
        </button>

        {isOpen && (
          <div className="absolute z-10 bg-white border border-gray-300 mt-2 w-full max-h-60 overflow-y-auto rounded shadow-md">
            {countries.map((country) => (
              <label
                key={country.name}
                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
              >
                <img
                  src={country.flag}
                  alt={country.name}
                  className="w-5 h-4"
                />
                <input
                  type="checkbox"
                  checked={selectedCountries.includes(country.name)}
                  onChange={() => handleCheckboxChange(country.name)}
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-800">{country.name}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="mt-6 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition w-full"
      >
        Submit Selection
      </button>
    </div>
  );
};

export default CountryCard;
